var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.347656 2.95407C0.347656 1.53914 1.77671 0.57162 3.09044 1.09711L10.9685 4.24834C11.4453 4.43907 11.9773 4.43906 12.4541 4.24834L22.3321 0.297112C22.809 0.106383 23.3409 0.106383 23.8177 0.297112L33.6958 4.24834C34.1726 4.43907 34.7045 4.43906 35.1813 4.24834L43.0594 1.09711C44.3731 0.57162 45.8022 1.53914 45.8022 2.95406V11.6364C45.8022 12.7409 44.9068 13.6364 43.8022 13.6364H2.34765C1.24309 13.6364 0.347656 12.7409 0.347656 11.6364V2.95407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8022 24.7272C45.8022 23.6227 44.9068 22.7272 43.8022 22.7272H2.34766C1.24309 22.7272 0.347656 23.6227 0.347656 24.7272V29.8182C0.347656 30.9227 1.24309 31.8182 2.34766 31.8182H34.7113C35.8159 31.8182 36.7113 32.7136 36.7113 33.8182V48C36.7113 49.1046 37.6067 50 38.7113 50H43.8022C44.9068 50 45.8022 49.1046 45.8022 48V24.7272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.347656 48C0.347656 49.1046 1.24309 50 2.34766 50H25.6204C26.725 50 27.6204 49.1046 27.6204 48V42.9091C27.6204 41.8045 26.725 40.9091 25.6204 40.9091H2.34766C1.24309 40.9091 0.347656 41.8045 0.347656 42.9091V48Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEf);
export default __webpack_public_path__ + "static/media/EF.0113274827aa0e84155f7c6984726897.svg";
export { ForwardRef as ReactComponent };